//@ts-nocheck
import PhoneInput from "react-phone-input-2";

export default function FlagPhoneInput({
  fontSize = "md",
  size = "lg",
  height = "50px",
  width = "100%",
  color = "blue",
  isInvalid,
  inputProps = {},
  ...rest
}: {
  fontSize?: string;
  size?: string;
  color?: string;
  isInvalid?: boolean;
  height?: string;
  width?: string;
  inputProps?: any;
  [key: string]: any;
}) {
  return (
    <PhoneInput
      inputProps={{ name: "phone", required: true, ...inputProps }}
      countryCodeEditable={false}
      inputClass={isInvalid ? "input-class invalid" : "input-class"}
      buttonClass="button-class"
      dropdownClass="dropdown-class"
      inputStyle={{
        height,
        width,
      }}
      {...rest}
    />
  );
}
